export const SET_ACORDO = 'MEUSACORDOS/ACORDO';
export const SET_ACORDOS = 'MEUSACORDOS/ACORDOS';